export function detectObjectType(object:any) {
    if(!object) {
        return null;
    }

    // contact
    if(object.hasOwnProperty('alternate_email')) {
        return 'contact';
    }

    // work plan
    if(object.hasOwnProperty('workplan_date')) {
        return 'workplan';
    }

    // business
    if(object.hasOwnProperty('dba_name')) {
        return 'business';
    }

    // property
    if(object.hasOwnProperty('owner_type')) {
        return 'property';
    }

    // event
    if(object.hasOwnProperty('event_category_id')) {
        return 'event';
    }

    // volunteer opportunity
    if(object.hasOwnProperty('event_id') && object.hasOwnProperty('workplan_id')) {
        return 'opportunity';
    }

    // donations
    if(object.hasOwnProperty('donor_id')) {
        return 'donation';
    }

    return null;
};
